import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { ValidateTimeSeriesType } from '../schema/types';
import { ValidateTimeSeriesMutationSchema } from '../schema/OutputDataSchema';

const postTimeSeriesValidateOutputData = async (
  request: ValidateTimeSeriesType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_TIMESERIES_VALIDATIONS,
      ValidateTimeSeriesMutationSchema.parse(request),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useTimeSeriesValidateOutputData = createApiMutationHook(
  ['validateTimeSeriesOutputData'],
  getMutationFn(postTimeSeriesValidateOutputData),
);
